export default __webpack_public_path__ + "media/images/garage-108461263859c8e8ace0daebdd5187ed.svg";